import {
    VISUALIZER_HEXAGON_SIZE_FACTOR_XS,
    VISUALIZER_HEXAGON_SIZE_FACTOR,
    VISUALIZER_SPEED_MULTIPLIER,
    VISUALIZER_SPEED_MULTIPLIER_XS,
} from '../constants';
import { Hexagon } from './Hexagon';

type CreateHexagonParams = {
    movementAreaWidth: number;
    movementAreaHeight: number;
    maskRadius: number;
    visualizerSize?: 'xs';
};

type BackgroundOrForegroundHexagonsParams = CreateHexagonParams & {
    hexagonBaseSize: number;
    maxSizeVariation: number;
};

const createBackgroundHexagons = ({
    hexagonBaseSize,
    maxSizeVariation,
    movementAreaWidth,
    movementAreaHeight,
    visualizerSize,
}: BackgroundOrForegroundHexagonsParams) =>
    Array(visualizerSize === 'xs' ? 40 : 100)
        .fill(0)
        .map(() => {
            const x = 0 + Math.random() * movementAreaWidth;
            const y = 0 + Math.random() * movementAreaHeight;
            const size = (hexagonBaseSize + Math.random() * maxSizeVariation) / 2;
            // Reduce base speed when size is 'xs'
            const speedMultiplier =
                visualizerSize === 'xs' ? VISUALIZER_SPEED_MULTIPLIER_XS : VISUALIZER_SPEED_MULTIPLIER;
            const baseSpeed = (0.5 + Math.random()) * 0.3 * speedMultiplier;
            return new Hexagon(x, y, size, baseSpeed);
        });

const createForegroundHexagons = ({
    hexagonBaseSize,
    maxSizeVariation,
    movementAreaWidth,
    movementAreaHeight,
    visualizerSize,
}: BackgroundOrForegroundHexagonsParams) =>
    Array(visualizerSize === 'xs' ? 50 : 100)
        .fill(0)
        .map(() => {
            const x = 0 + Math.random() * movementAreaWidth;
            const y = 0 + Math.random() * movementAreaHeight;
            const size = hexagonBaseSize + Math.random() * maxSizeVariation;
            // Reduce base speed when size is 'xs'
            const speedMultiplier =
                visualizerSize === 'xs' ? VISUALIZER_SPEED_MULTIPLIER_XS : VISUALIZER_SPEED_MULTIPLIER;
            const baseSpeed = (0.5 + Math.random()) * speedMultiplier;
            return new Hexagon(x, y, size, baseSpeed);
        });

export const createHexagons = ({
    maskRadius,
    movementAreaWidth,
    movementAreaHeight,
    visualizerSize,
}: CreateHexagonParams) => {
    const hexagonBaseSize = maskRadius * 0.08; // Calculate base size from mask radius
    const hexagonSizeFactor =
        visualizerSize === 'xs' ? VISUALIZER_HEXAGON_SIZE_FACTOR_XS : VISUALIZER_HEXAGON_SIZE_FACTOR;
    const maxSizeVariation = hexagonBaseSize * hexagonSizeFactor; // Calculate variation based on factor

    const backGroundHexagons = createBackgroundHexagons({
        hexagonBaseSize,
        maxSizeVariation,
        movementAreaWidth,
        movementAreaHeight,
        maskRadius,
        visualizerSize,
    });

    const foregroundHexagons = createForegroundHexagons({
        hexagonBaseSize,
        maxSizeVariation,
        movementAreaWidth,
        movementAreaHeight,
        maskRadius,
        visualizerSize,
    });

    return { backGroundHexagons, foregroundHexagons };
};
